var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvernightParkingCoral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Overnight_parking_-_Coral"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 41.341,
    cy: 104.77,
    r: 8.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 89.008,
    cy: 104.77,
    r: 8.22
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 49.561,
    y1: 104.77,
    x2: 80.788,
    y2: 104.77
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M97.051,104.903h9.161 c3.321,0,6.013-2.692,6.013-6.013v-8.732c0-0.587-0.172-1.16-0.494-1.651L94.46,62.213"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M33.122,104.77h-7.775 c-3.321,0-6.013-2.692-6.013-6.013V54.836c0-3.321,2.692-6.013,6.013-6.013h76.298c1.147,0,2.195,0.653,2.7,1.684l4.611,9.409 c0.489,0.999-0.238,2.165-1.35,2.165H85.446c-1.66,0-3.006,1.346-3.006,3.006V78.43c0,1.66,1.346,3.006,3.006,3.006h21.165"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M33.122,68.094v7.861 c0,3.321,2.692,6.013,6.013,6.013h23.505c3.321,0,6.013-2.692,6.013-6.013v-7.861c0-3.321-2.692-6.013-6.013-6.013H39.135 C35.814,62.081,33.122,64.773,33.122,68.094z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M98.107,16.569h5.614 c0.249,0,0.409,0.186,0.296,0.342l-5.662,7.819c-0.113,0.156,0.047,0.342,0.296,0.342h5.614"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M76.502,37.217h3.743 c0.166,0,0.273,0.124,0.197,0.228l-3.775,5.213c-0.076,0.104,0.032,0.228,0.197,0.228h3.743"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M86.792,27.401h4.678 c0.207,0,0.341,0.155,0.247,0.285l-4.718,6.516c-0.094,0.13,0.039,0.285,0.247,0.285h4.678"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvernightParkingCoral);
export default __webpack_public_path__ + "static/media/Overnight Parking - Coral.e8a0115d4c875f12bba8e26fc9b5529f.svg";
export { ForwardRef as ReactComponent };